const LOCALSTORAGE_KEYS = {
  TOKEN: '@my-security/token',
  ACCOUNT_ID_SELECTED: '@my-security/account-id-selected',
  LANGUAGE: '@my-security/language',
  URL_LOGOUT: '@my-security/url-logout',
  COMPANY_ID: '@my-security/company-id',
  MASTER_COMPANY_ID: '@my-security/master-company-id',
  DEVICE_ID: '@my-security/device-id',
};

export default LOCALSTORAGE_KEYS;
